import { Components } from '@mui/material';
import { buttonClasses } from '@mui/material/Button';

import tokens from '../tokens';

const MuiButton: NonNullable<Components['MuiButton']> = {
  defaultProps: {
    variant: 'contained',
    disableElevation: true,
  },
  styleOverrides: {
    root: {
      whiteSpace: 'nowrap',

      [`&.${buttonClasses.sizeMedium}`]: {
        minHeight: '2.5rem',
      },

      [`&.${buttonClasses.containedSecondary}`]: {
        backgroundColor: tokens.palette.primary.light,
        borderColor: tokens.palette.primary.light,
        color: tokens.palette.primary.main,
      },

      [`& .${buttonClasses.startIcon}`]: {
        marginLeft: 0,
        marginRight: tokens.spacing(2),
      },

      [`& .${buttonClasses.endIcon}`]: {
        marginLeft: tokens.spacing(2),
        marginRight: 0,
      },
    },
  },
};

export default MuiButton;
